import Loader from '@/components/Loader';
import { cn } from '@/utils';

function PageLoader({ message = 'Loading...', className }) {
  return (
    <div
      className={cn('min-h-[50vh] flex flex-col items-center justify-center gap-4', className)}
      role="status"
      aria-live="polite"
    >
      <Loader size="lg" />
      <p className="text-sm text-gray-500">{message}</p>
    </div>
  );
}

export default PageLoader;
